import { Navigate } from 'react-router-dom';
import { useSelector } from 'store';
import { ReactElement } from 'react';

interface AdminGuardProps {
  children: ReactElement | null;
}

/**
 * Restricts a route to system administrators (`Role === 'admin'`).
 */
export default function AdminGuard({ children }: AdminGuardProps) {
  const user = useSelector((state) => state.user);

  if (user?.Role === 'admin') return children;

  return <Navigate to="/profile" replace />;
}
